module.exports = __webpack_public_path__ + "static/media/jo.e0c3d125.svg";